import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Slide from "@material-ui/core/Slide";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { Formik } from "formik";
import PropTypes from "prop-types";
import React from "react";
import * as Yup from "yup";

import { ContentTypeEnum } from "@utils/message";
import { uniqueKey } from "@utils/react";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles(() => ({
  content: {
    width: "520px",
    overflow: "Hidden",
  },
}));

const contentTypeOptions = [
  {
    label: "Texto",
    value: ContentTypeEnum.TEXT,
  },
  {
    label: "Binário",
    value: ContentTypeEnum.BINARY,
  },
  {
    label: "Binário Especial",
    value: ContentTypeEnum.SPECIAL_BINARY,
  },
];

const defaultInitialValues = {
  id: "",
  contentType: ContentTypeEnum.TEXT,
  message: "",
};

function MessageInputDialog(props) {
  const classes = useStyles();

  function applyDataToInitialValues(data) {
    return {
      id: data.id,
      contentType: data.contentType,
      message: data.message,
    };
  }

  function isEditMode() {
    return !!props.data;
  }

  const initialValues = props.data
    ? applyDataToInitialValues(props.data)
    : defaultInitialValues;
  const validationSchema = Yup.object().shape({
    message: Yup.string().required("Campo requerido"),
  });

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      validateOnMount={true}
      enableReinitialize
    >
      {(context) => {
        const {
          errors,
          touched,
          isValid,
          values,
          resetForm,
          setFieldTouched,
          setFieldValue,
          handleChange,
          handleBlur,
        } = context;

        function handleClose() {
          props.onClose();
          resetForm();
        }

        function handleAdd() {
          props.onApply({
            id: uniqueKey(),
            contentType: values.contentType,
            message: values.message,
          });
          resetForm();
        }

        function handleCancel() {
          props.onCancel();
          resetForm();
        }

        function isBinaryMessage() {
          return (
            values.contentType === ContentTypeEnum.BINARY ||
            values.contentType === ContentTypeEnum.SPECIAL_BINARY
          );
        }

        return (
          <Dialog
            open={props.open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
          >
            <DialogTitle>Adicionar mensagem</DialogTitle>

            <DialogContent className={classes.content}>
              <Grid container spacing={3}>
                {/* Binary messages disabled.
                <Grid item xs={12}>
                  <FormControl
                    fullWidth
                    variant="outlined"
                    error={touched.contentType && errors.contentType}
                    required
                  >
                    <InputLabel id="content-type-select">
                      Tipo de Conteúdo
                    </InputLabel>
                    <Select
                      labelId="content-type-select"
                      name="contentType"
                      label="Tipo de Conteúdo *"
                      value={values.contentType}
                      onChange={(e) => {
                        setFieldValue("message", "");
                        setFieldTouched("message", false);
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                    >
                      {contentTypeOptions.map((option) => (
                        <MenuItem key={uniqueKey()} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                    {touched.contentType && errors.contentType && (
                      <FormHelperText>{errors.contentType}</FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                */}
                <Grid item xs={12}>
                  <TextField
                    value={values.message}
                    variant="outlined"
                    fullWidth
                    label="Mensagem"
                    name="message"
                    multiline
                    rows={6}
                    required
                    helperText={touched.message ? errors.message : ""}
                    error={touched.message && Boolean(errors.message)}
                    onChange={(e) => {
                      if (isBinaryMessage()) {
                        handleChange(e);
                      } else {
                        handleChange(e);
                      }
                    }}
                    onBlur={handleBlur}
                  />
                </Grid>
              </Grid>
            </DialogContent>

            <DialogActions>
              <Button onClick={handleCancel}>Cancelar</Button>
              <Button onClick={handleAdd} color="primary" disabled={!isValid}>
                {isEditMode() ? "Salvar" : "Adicionar"}
              </Button>
            </DialogActions>
          </Dialog>
        );
      }}
    </Formik>
  );
}

MessageInputDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  data: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

MessageInputDialog.defaultProps = {
  open: false,
  data: null,
  onClose: () => {},
  onApply: () => {},
  onCancel: () => {},
};

export default MessageInputDialog;
